import { IMerchantConfig } from '../@interfaces/config.interface';
import styles from '../styles/TermsAndConditions.module.css';

//
//

type TermsAndConditionsProps = {
  merchantConfig: IMerchantConfig;
};

export const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({ merchantConfig }) => {
  if (!merchantConfig?.termsAndConditionsHtml) {
    return null;
  }

  return (
    <p
      className={styles.privacyPolicy}
      dangerouslySetInnerHTML={{ __html: merchantConfig.termsAndConditionsHtml }}
    />
  );
};
